import { Link } from 'gatsby'
import React, { useState } from 'react'
import Form from './Form'
import Stepper from './Stepper'
import StepFour from './FormAtoms/StepFour'
import StepOne from './FormAtoms/StepOne'
import StepThree from './FormAtoms/StepThree'
import StepTwo from './FormAtoms/StepTwo'
const FormWrapper = ({data}) => {
    const steps = [
        {
            name: 'useCase',
            question: data?.useCase?.question,
            options: data?.useCase?.options?.map((option) => option.text),
            image: data?.useCase?.image,
            description: data?.useCase?.description,
            component: StepOne
        },

        {
            name: 'questionaire',
            question: 'Questionnaire (NIST Framework)',
            substeps: data?.questionnaire?.steps?.map(({ step }) => {
                return {
                    name: step?.uniqueName,
                    title: step?.title,
                    description: step?.title,
                    questions: step?.questions?.map(({ text }) => text) || []
                }
            }) || [],
            statistic: data?.statistic,
            component: StepTwo
        },
       
    ]
    const [step, setStep] = useState(1)
    const [subStep, setSubStep] = useState(1)

    const goBack = () => {
        if (steps?.[step - 1]?.substeps) {
            if (subStep === 1) {
                setStep((pre) => pre - 1)
                return
            }
            setSubStep((pre) => pre - 1)
            return
        }
        setStep((pre) => pre - 1)
    }

    return (
        <section className="pb-20 lg:pt-16 lg:pb-[120px] lg:mt-10">
            <div className="bg-dark_purple">
                <div className='relative container py-8'>
                {step == 1 && <Link
                    to="/cyber-security-maturity-assessment/"
                    className="inline-flex absolute left-8 lg:left-10 top-5 md:top-1/2 -translate-y-1/2 items-center gap-x-2 transition-opacity duration-300 text-white text-base lg:text-xl font-grotesk-light"
                >
                    {"< "}<span className='hover:underline'>Back</span>
                </Link>}

                {step > 1 && step<3 && <span
                    onClick={() => goBack()}
                    className="inline-flex absolute cursor-pointer left-8 lg:left-10 top-5 md:top-1/2 -translate-y-1/2 items-center gap-x-2 transition-opacity duration-300 text-white text-base lg:text-xl font-grotesk-light"
                >
                    {"< "}<span className='hover:underline'>Back</span>
                </span>}
                <h1 className=' text-center text-white text-xl lg:text-3xl font-grotesk-bold'>Cyber Security - Maturity Assessment</h1>
                </div>
            </div>
            <Form 
                steps={steps}
                step={step} 
                setStep={setStep} 
                data={data}
                goBack={goBack}
                subStep={subStep}
                setSubStep={setSubStep}
            />

        </section>
    )
}


export default FormWrapper
